// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "   body > .grid {\r\n      height: 100%;\r\n    }\r\n    .image {\r\n      margin-top: -100px;\r\n    }\r\n    .column {\r\n      max-width: 450px;\r\n    }", ""]);
// Exports
module.exports = exports;
